// extracted by mini-css-extract-plugin
export var brand = "_5p-9";
export var compact = "_5p-6";
export var extraSmall = "_5p-7";
export var icon = "_5p-0";
export var large = "_5p-4";
export var light = "_5p-1";
export var medium = "_5p-5";
export var outline = "_5p-b";
export var primaryDark = "_5p-a";
export var primaryLight = "_5p-8";
export var primaryModern = "_5p-c";
export var success = "_5p-2";
export var successSolid = "_5p-3";